import { render, staticRenderFns } from "./InteractiveBlock.vue?vue&type=template&id=16fc78f4&scoped=true&"
import script from "./InteractiveBlock.vue?vue&type=script&lang=js&"
export * from "./InteractiveBlock.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveBlock.vue?vue&type=style&index=0&id=16fc78f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc78f4",
  null
  
)

export default component.exports